import React from 'react';
import Popper, { HintPlacement } from '@zvuk-b2b/react-uikit/ui/Popper';
import { useDetectTextOverflow } from 'application/hooks';
import { MediafileDetailsProps } from './types';
import { DATA_TEST_IDS, TITLE_HINT_OFFSET, TITLE_SELECTOR } from './consts';

const MediafileDetails: React.FC<MediafileDetailsProps> = ({
  title,
  className,
  titleClassName,
  popperClassName,
  children,
}) => {
  const { isOverflow, textRef } = useDetectTextOverflow(TITLE_SELECTOR);

  return (
    <div
      ref={textRef}
      className={className}>
      <Popper
        placement={HintPlacement.PLACEMENT_TOP_START}
        containerClassName={popperClassName}
        isShow={isOverflow}
        offset={TITLE_HINT_OFFSET}
        triggerNode={
          <span
            data-testid={DATA_TEST_IDS.TITLE}
            className={titleClassName}>
            {title}
          </span>
        }>
        {title}
      </Popper>
      {children}
    </div>
  );
};

export default MediafileDetails;
